import { z } from "zod";
/**
 * BG-002 — shared entry verification convention for BusinessGraph field ids.
 * Import suggestions remain quarantined in ImportDraft until agency decision.
 * AI structured extraction (AI-001) is deferred; no AI truth write path.
 */
export const BusinessGraphEntryVerificationV1Schema = z.enum(["CANDIDATE", "VERIFIED"]);
export const BusinessGraphEntrySourceV1Schema = z.enum([
    "intake",
    "agency",
    "import-suggestion",
    "import-confirmed",
]);
/** Explicit policy: which entry sources start unverified vs policy-permitted verified. */
export const DEFAULT_ENTRY_VERIFICATION_POLICY = {
    intake: "CANDIDATE",
    agency: "VERIFIED",
    "import-suggestion": "CANDIDATE",
    "import-confirmed": "VERIFIED",
    /** AI-001 deferred — if a future path appears it must remain CANDIDATE until confirm. */
    "ai-extracted": "CANDIDATE",
};
/** Id substrings that mark a BusinessGraph record as unverified/candidate. */
export const UNCONFIRMED_ID_MARKERS = [
    "unconfirmed",
    "draft-import",
    "import-suggestion",
    "intake-unverified",
];
export function recordIsUnconfirmedEntryId(id) {
    const lower = id.toLowerCase();
    return UNCONFIRMED_ID_MARKERS.some((marker) => lower.includes(marker));
}
export function entryVerificationForSource(source, policy = DEFAULT_ENTRY_VERIFICATION_POLICY) {
    return policy[source];
}
/** Stable unverified id for intake-derived / candidate fields. */
export function idForUnverifiedEntry(kind, index) {
    return `intake-unverified-${kind}_${index + 1}`;
}
/** Verified (policy-permitted) id for agency-confirmed import fields. */
export function idForVerifiedImportEntry(kind, index) {
    return kind === "service" ? `import_svc_${index + 1}` : `import_area_${index + 1}`;
}
//# sourceMappingURL=business-graph-entry-state.js.map